// Keuzes die de browser onthoudt (localStorage, per browser): filters en weergavekeuzes van een scherm blijven staan
// als je van tabblad wisselt of herlaadt. Een waarde die niet meer klopt (ander type, oude versie) valt terug op de
// beginwaarde; in een privévenster werkt het als gewone toestand.
import { useEffect, useState, type Dispatch, type SetStateAction } from "react";

export function readPref<T>(key: string, ok: (v: unknown) => v is T, init: T): T {
  try {
    const s = window.localStorage.getItem(key);
    if (s !== null) { const v: unknown = JSON.parse(s); if (ok(v)) return v; }
  } catch { /* privévenster of een oude waarde */ }
  return init;
}

export function usePref<T>(key: string, init: T, ok: (v: unknown) => v is T): [T, Dispatch<SetStateAction<T>>] {
  const [v, setV] = useState<T>(() => readPref(key, ok, init));
  useEffect(() => {
    try { window.localStorage.setItem(key, JSON.stringify(v)); } catch { /* privévenster */ }
  }, [key, v]);
  return [v, setV];
}

export const isBool = (v: unknown): v is boolean => typeof v === "boolean";
export const isStr = (v: unknown): v is string => typeof v === "string";
export const isStrOrNull = (v: unknown): v is string | null => v === null || typeof v === "string";
export const isStrList = (v: unknown): v is string[] => Array.isArray(v) && v.every((x) => typeof x === "string");
export const isBoolMap = (v: unknown): v is Record<string, boolean> =>
  !!v && typeof v === "object" && !Array.isArray(v) && Object.values(v).every((x) => typeof x === "boolean");
export const oneOf = <T extends string>(...opts: T[]) => (v: unknown): v is T => opts.includes(v as T);
